import { BoxRestriction, BoxRestrictionType } from '../../models/box-restriction';
import boxRestrictionsService from '../../services/box-restrictions-service';
import { SizingStore } from './sizing-store';

export class GetBoxRestrictionsAction {
  async getBoxRestrictions(this: SizingStore): Promise<void> {
    // Fetch per distinct CG2 present across the order's sizing groups, not just this.cgCode2
    // (the order's first article), so restrictions for other departments in the same order
    // (e.g., a Women's row in a Men-first order) are also retrieved.
    const cg2Codes = new Set(this.sizingGroups.map((group) => group.commodityGroup.codes[1]).filter(Boolean));
    if (cg2Codes.size === 0) {
      cg2Codes.add(this.cgCode2);
    }

    const responses = await Promise.all(
      Array.from(cg2Codes).map((cg2Code) =>
        boxRestrictionsService.getBoxRestrictions(this.brandCode, cg2Code, this.supplierCode)
      )
    );
    const boxRestrictionsById = new Map(
      responses.flat().map((boxRestrictionRaw) => [boxRestrictionRaw.id, boxRestrictionRaw])
    );
    const boxRestrictions = Array.from(boxRestrictionsById.values());
    this.boxRestrictions = boxRestrictions.map<BoxRestriction>((boxRestrictionRaw) => {
      const boxRestrictionId = String(boxRestrictionRaw.id);

      const cg1Code = boxRestrictionRaw.cg1?.code;
      const cg2Code = boxRestrictionRaw.cg2?.code;
      const cg3Codes = boxRestrictionRaw.cg3?.map((cg3) => cg3.code);

      if (boxRestrictionRaw.type === BoxRestrictionType.LOT_GROUP) {
        return {
          id: boxRestrictionId,
          name: boxRestrictionRaw.name,
          type: boxRestrictionRaw.type,
          orderType: boxRestrictionRaw.basic_order_type,
          sizeRange: boxRestrictionRaw.size_range,
          lotGroup: boxRestrictionRaw.lot_group?.map((lot) => ({
            id: String(lot.box_restriction_id),
            name: lot.name,
            distribution: lot.distribution,
          })),
          updatedAt: boxRestrictionRaw.updated_at,
          cg1Code,
          cg2Code,
          cg3Codes,
        } as BoxRestriction;
      } else {
        return {
          id: boxRestrictionId,
          name: boxRestrictionRaw.name,
          type: boxRestrictionRaw.type,
          orderType: boxRestrictionRaw.basic_order_type,
          boxValue: boxRestrictionRaw.box_value,
          updatedAt: boxRestrictionRaw.updated_at,
          cg1Code,
          cg2Code,
          cg3Codes,
        } as BoxRestriction;
      }
    });
  }
}
